const styles = (theme) => ({
  container: {
    padding: theme.spacing(1, 0),
    margin: theme.spacing(0),
    overflowX: 'auto',
    overflowY: 'hidden',
    display: 'flex',
    height: 48,
    maxWidth: theme.breakpoints.values.sm,
    '& div:first-child': {
      marginLeft: theme.spacing(2.5),
    },
    '& span': {
      marginLeft: theme.spacing(0),
    },
  },
  placeholder: {
    minWidth: theme.spacing(1.5),
  },
  chip: {
    marginRight: theme.spacing(1),
  },
  chipRoot: {
    maxWidth: '100%',
  },
  deleteIcon: {
    width: 14,
    height: 14,
  },
});

export default styles;
